import React, { memo, useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { changeSeveralValues } from '../../../redux/actions/chickenDashAction';
import { getIntervalState } from '../../../hooks/useChartInterval';
import { useClosedDays } from '../../../hooks/useClosedDays';
import { DateTimepicker } from '../../../components';

const DashboardToolbarDateTimePicker = ({ changedSearch, setChangedSearch }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const timezone = useSelector(state => state.chickenDashboard.timezone);
  const startDate = useSelector(state => state.chickenDashboard.startDate);
  const endDate = useSelector(state => state.chickenDashboard.endDate);
  const timeInterval = useSelector(state => state.chickenDashboard.timeInterval);
  const startTimeInterval = useSelector(state => state.chickenDashboard.startTimeInterval);
  const endTimeInterval = useSelector(state => state.chickenDashboard.endTimeInterval);
  const restaurantUuid = useSelector(state => state.chickenDashboard.restaurantUuid);

  const closedDays = useClosedDays(restaurantUuid);
  
  const changeStoreSeveralValues = useCallback(value => {
    dispatch(changeSeveralValues(value));
  }, [dispatch]);
  
  const onDateChange = useCallback((value, end = null) => {
    setChangedSearch(false);
    let newStartDate;
    let newEndDate;
    
    if (end === null) {
      newStartDate = null;
    } else {
      if (value !== 'select') {
        newStartDate = (end ? end : Date.now()) - Number(value) * 1000;
      } else {
        newStartDate = value;
      }
    }
    
    if (end === null) {
      newEndDate = null;
    } else {
      if (value !== 'select') {
        newEndDate = end || Date.now();
      } else {
        newEndDate = value;
      }
    }
    
    const newValues = {
      startDate: newStartDate,
      endDate: newEndDate,
      timeInterval: end === null ? value : null,
      intervalEnd: end === null ? Date.now() : null,
    };
    
    const newIntervalState = getIntervalState(
      newValues.startDate,
      newValues.endDate,
      newValues.timeInterval,
    );
    
    if (newIntervalState?.defaultIntervalValue) {
      newValues.interval = newIntervalState.defaultIntervalValue;
    }
  
    changeStoreSeveralValues(newValues);
  }, [changeStoreSeveralValues, setChangedSearch]);
  
  const specificTime = useMemo(() => {
    return {
      startTimeInterval,
      endTimeInterval,
      onApply: (newStartTimeInterval, newEndTimeInterval) => {
        changeStoreSeveralValues({
          startTimeInterval: newStartTimeInterval,
          endTimeInterval: newEndTimeInterval,
        });
      },
    };
  }, [startTimeInterval, endTimeInterval, changeStoreSeveralValues]);
  
  return (
    <DateTimepicker
      history={history}
      timezone={timezone !== null ? timezone : undefined}
      value={startDate}
      end={endDate}
      timeInterval={timeInterval}
      defaultValue="today"
      onChange={onDateChange}
      changedSearch={changedSearch}
      setChangedSearch={setChangedSearch}
      specificTime={specificTime}
      disableDay={date => closedDays.includes(date.getDay())}
      closedDays={closedDays}
    />
  );
};

export default memo(DashboardToolbarDateTimePicker);